import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

const baseURL =
    import.meta.env.VITE_BILLING_CONSOLIDATED_API_URL || "http://localhost:4005/api";

const billingConsolidatedApi: AxiosInstance = axios.create({
    baseURL,
    headers: {
        "Content-Type": "application/json",
    },
});

setupAuthInterceptor(billingConsolidatedApi);

billingConsolidatedApi.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
        return Promise.reject(error.response || "Algo salió mal");
    }
);

export { billingConsolidatedApi };
